import React, {Component} from 'react';

export default class Science extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
